module.exports = __webpack_public_path__ + "img/barcelona-logo-icon.6e14054b.png";